import { auxiliaryShadows, innerShadow, solidShadows } from "./shadows";

const solidFocusStyle = "data-[focus-visible=true]:outline";
const solidDisabledStyle =
  "data-[disabled=true]:bg-neutral-300 data-[disabled=true]:text-neutral-400";

const outlinedFocusStyle = "data-[focus-visible=true]:outline-0 data-[focus-visible=true]:border-4";
const outlinedDisabledStyle =
  "data-[disabled=true]:border-neutral-300 data-[disabled=true]:text-neutral-400";

const linkFocusStyle =
  "data-[focus-visible=true]:outline-neutral-300 data-[focus-visible=true]:outline-4 data-[focus-visible=true]:outline-offset-0";
const linkDisabledStyle = "data-[disabled=true]:text-neutral-400";

const solid = {
  primary: [
    "bg-fx-primary text-fx-neutral-50",
    "data-[hover=true]:bg-fx-primary-700",
    "data-[active=true]:bg-fx-primary-700",
    "data-[pressed=true]:bg-fx-primary-900",
    "data-[focus-visible=true]:outline-fx-primary-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  secondary: [
    "bg-fx-secondary text-fx-neutral-50",
    "data-[hover=true]:bg-fx-secondary-700",
    "data-[active=true]:bg-fx-secondary-700",
    "data-[pressed=true]:bg-fx-secondary-900",
    "data-[focus-visible=true]:outline-fx-secondary-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  tertiary: [
    "bg-tertiary-800 text-neutral-50",
    "data-[hover=true]:bg-tertiary-700",
    "data-[active=true]:bg-tertiary-600",
    "data-[pressed=true]:bg-tertiary-500",
    "data-[focus-visible=true]:outline-tertiary-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  success: [
    "bg-fx-success text-fx-neutral-50",
    "data-[hover=true]:bg-fx-success-700",
    "data-[active=true]:bg-fx-success-700",
    "data-[pressed=true]:bg-fx-success-900",
    "data-[focus-visible=true]:outline-fx-success-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  warning: [
    "bg-fx-warningY text-fx-neutral-900",
    "data-[hover=true]:bg-fx-warningY-500",
    "data-[active=true]:bg-fx-warningY-500",
    "data-[pressed=true]:bg-fx-warningY-900",
    "data-[focus-visible=true]:outline-fx-warningY-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  danger: [
    "bg-fx-danger text-fx-neutral-50",
    "data-[hover=true]:bg-fx-danger-700",
    "data-[active=true]:bg-fx-danger-700",
    "data-[pressed=true]:bg-fx-danger-900",
    "data-[focus-visible=true]:outline-fx-danger-500",
    solidFocusStyle,
    solidDisabledStyle,
    ...solidShadows,
  ],
  contrast: [
    "bg-neutral-950 text-neutral-50",
    "data-[hover=true]:bg-neutral-950",
    "data-[pressed=true]:bg-neutral-950",
    "data-[focus-visible=true]:outline-neutral-950",
    solidFocusStyle,
    solidDisabledStyle,
  ],
  black: [
    "bg-black text-fx-neutral-50",
    "data-[hover=true]:bg-black",
    "data-[pressed=true]:bg-black",
    "data-[focus-visible=true]:outline-black",
    solidFocusStyle,
    solidDisabledStyle,
  ],
};

const solidNoHover = Object.fromEntries(
  Object.entries(solid).map(([key, variants]) => [
    key,
    variants.filter((variant) => !variant.startsWith("data-[hover=true]:")),
  ]),
);

const outlined = {
  primary: [
    "bg-transparent border-primary text-primary",
    "data-[hover=true]:border-primary-700 data-[hover=true]:text-primary-700",
    "data-[active=true]:border-primary-700 data-[active=true]:text-primary-700",
    "data-[pressed=true]:border-primary-800 data-[pressed=true]:text-primary-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  secondary: [
    "bg-transparent border-secondary text-secondary",
    "data-[hover=true]:border-secondary-700 data-[hover=true]:text-secondary-700",
    "data-[active=true]:border-secondary-700 data-[active=true]:text-secondary-700",
    "data-[pressed=true]:border-secondary-800 data-[pressed=true]:text-secondary-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  tertiary: [
    "bg-transparent border-tertiary text-tertiary",
    "data-[hover=true]:border-tertiary-600 data-[hover=true]:text-tertiary-600",
    "data-[active=true]:border-tertiary-600 data-[active=true]:text-tertiary-600",
    "data-[pressed=true]:border-tertiary-700 data-[pressed=true]:text-tertiary-700",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  success: [
    "bg-transparent border-success text-success",
    "data-[hover=true]:border-success-700 data-[hover=true]:text-success-700",
    "data-[active=true]:border-success-700 data-[active=true]:text-success-700",
    "data-[pressed=true]:border-success-800 data-[pressed=true]:text-success-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  warning: [
    "bg-transparent border-warningO text-warningO",
    "data-[hover=true]:border-warning-500 data-[hover=true]:text-warning-500",
    "data-[active=true]:border-warning-500 data-[active=true]:text-warning-500",
    "data-[pressed=true]:border-warning-600 data-[pressed=true]:text-warning-600",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  danger: [
    "bg-transparent border-danger text-danger",
    "data-[hover=true]:border-danger-700 data-[hover=true]:text-danger-700",
    "data-[active=true]:border-danger-700 data-[active=true]:text-danger-700",
    "data-[pressed=true]:border-danger-800 data-[pressed=true]:text-danger-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  salesP: [
    "bg-transparent border-salesP text-salesP",
    "data-[hover=true]:border-salesP-700 data-[hover=true]:text-salesP-700",
    "data-[active=true]:border-salesP-700 data-[active=true]:text-salesP-700",
    "data-[pressed=true]:border-salesP-800 data-[pressed=true]:text-salesP-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
  salesR: [
    "bg-transparent border-salesR text-salesR",
    "data-[hover=true]:border-salesR-700 data-[hover=true]:text-salesR-700",
    "data-[active=true]:border-salesR-700 data-[active=true]:text-salesR-700",
    "data-[pressed=true]:border-salesR-800 data-[pressed=true]:text-salesR-800",
    outlinedFocusStyle,
    outlinedDisabledStyle,
  ],
};

const link = {
  primary: [
    "bg-transparent",
    "text-primary",
    "data-[hover=true]:text-primary-700",
    "data-[active=true]:text-primary-700",
    "data-[pressed=true]:text-primary-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
  secondary: [
    "bg-transparent",
    "text-secondary",
    "data-[hover=true]:text-secondary-700",
    "data-[active=true]:text-secondary-700",
    "data-[pressed=true]:text-secondary-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
  tertiary: [
    "bg-transparent",
    "text-tertiary",
    "data-[hover=true]:text-tertiary-700",
    "data-[active=true]:text-tertiary-700",
    "data-[pressed=true]:text-tertiary-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
  success: [
    "bg-transparent",
    "text-success",
    "data-[hover=true]:text-success-700",
    "data-[active=true]:text-success-700",
    "data-[pressed=true]:text-success-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
  warning: [
    "bg-transparent",
    "text-warningO",
    "data-[hover=true]:text-warningO-700",
    "data-[active=true]:text-warningO-700",
    "data-[pressed=true]:text-warningO-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
  danger: [
    "bg-transparent",
    "text-danger",
    "data-[hover=true]:text-danger-700",
    "data-[active=true]:text-danger-700",
    "data-[pressed=true]:text-danger-800",
    linkFocusStyle,
    linkDisabledStyle,
  ],
};

const auxiliary = {
  default: [
    "transition-all",
    "border-0",
    "bg-neutral-25 border-neutral-200 text-foreground-900",
    "data-[hover=true]:bg-neutral-50",
    "data-[active=true]:bg-neutral-100",
    "data-[pressed=true]:bg-neutral-100",
    "data-[active=true]:text-neutral-900",
    "data-[pressed=true]:text-neutral-900",
    "data-[focus-visible=true]:outline-neutral-500",
    "data-[disabled=true]:bg-neutral-300 data-[disabled=true]:text-neutral-400",
    solidFocusStyle,
    ...auxiliaryShadows,
  ],
  accordionBase: [
    "transition-all",
    "text-neutral-500",
    "hover:bg-neutral-50",
    "active:bg-neutral-100",
    "pressed:bg-neutral-100",
    "data-[open=true]:bg-neutral-100",
    "active:text-neutral-900",
    "pressed:text-neutral-900",
    "focus:outline-neutral-500",
    " data-[disabled=true]:text-neutral-400",
    "data-[selected=true]:bg-neutral-100",
    solidFocusStyle,
    // ...auxiliaryShadows,
  ],
};

const buttonGroup = {
  default: [
    "border-r border-r-neutral-200 last:border-none",
    "[&:not(:first-child):not(:last-child)]:rounded-none first:rounded-e-none last:rounded-s-none",
    "whitespace-nowrap",
    "min-w-max",
    "font-semibold",
    "text-neutral-500",
    "overflow-hidden",
    "tap-highlight-transparent",
    "bg-neutral-25",
    "data-[hover=true]:bg-neutral-50",
    "data-[pressed=true]:text-neutral-900",
    "data-[pressed=true]:bg-neutral-100",
    "data-[active=true]:text-neutral-900",
    "data-[active=true]:bg-neutral-100",
    "data-[disabled=true]:text-neutral-400",
    solidFocusStyle,
    "data-[focus-visible=true]:outline-neutral-500",
    "data-[focus-visible=true]:outline-2",
    "data-[focus-visible=true]:z-10",
    ...innerShadow,
  ],
};

const flat = {
  primary: "bg-primary-100 dark:bg-primary-800 text-primary dark:text-primary-400",
  secondary: "bg-secondary-100 dark:bg-secondary-800 text-secondary dark:text-secondary-400",
  tertiary: "bg-default-500 text-white",
  success: "bg-success-100 dark:bg-success-800 text-success-600 dark:text-success-400",
  warning: "bg-warningY-100 dark:bg-warningY-800 text-warningO-600 dark:text-warningO-400",
  ["warning-secondary"]:
    "bg-warning-secondary-100 dark:bg-warning-secondary-800 text-warning-secondary dark:text-warning-secondary-400",
  danger: "bg-danger-100 dark:bg-danger-800 text-danger dark:text-danger-400",
  foreground: "bg-foreground/10 text-foreground",
};

const colorStoriesOptions = {
  control: {
    type: "select",
  },
  options: Object.keys(solid),
  description: "The colors",
};

export const colorVariants = {
  solid,
  solidNoHover,
  outlined,
  link,
  auxiliary,
  buttonGroup,
  flat,
  colorStoriesOptions,
};
